import { render, staticRenderFns } from "./SubFranchiseUserDetail.vue?vue&type=template&id=b354d276&"
import script from "./SubFranchiseUserDetail.vue?vue&type=script&lang=js&"
export * from "./SubFranchiseUserDetail.vue?vue&type=script&lang=js&"
import style0 from "./SubFranchiseUserDetail.vue?vue&type=style&index=0&id=b354d276&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports